import Axios from 'axios';
import pako from 'pako'
import { openProgressModal } from '@process-advisor/process-miner/api/methods/modals/openProgressModal';
import { closeProgressModal } from '@process-advisor/process-miner/api/methods/modals/closeProgressModal';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { setSaveModel } from '@process-advisor/process-miner/processMiner/processMiner';
import { filteredTasksCount } from '@process-advisor/process-miner/processMiner/processMiner';
import { Buffer } from 'buffer';


const preserveProcessModelBillingFields = (processModel = {}) => ({
    ai_credit_authorized: processModel.ai_credit_authorized ?? false,
    ai_credit_authorized_at: processModel.ai_credit_authorized_at ?? null,
    ai_credit_authorization_id: processModel.ai_credit_authorization_id ?? null,
    ai_credit_authorized_count: processModel.ai_credit_authorized_count ?? 0,
    ai_credit_required_count: processModel.ai_credit_required_count ?? 0,
    ai_credit_record_count: processModel.ai_credit_record_count ?? 0,
    ai_credit_public_key_hash: processModel.ai_credit_public_key_hash ?? null,
    ai_credit_authorization_meta: processModel.ai_credit_authorization_meta ?? null,
});

const noopModule = {
  invoke: () => Promise.resolve({ active: true, type: 'COMMERCIAL', items: [], result: [], customer_id: '' }),
  requestJira: () => Promise.resolve({
    json: () => Promise.resolve({ groups: { items: [] }, accountId: '', values: [], siteUrl: '' })
  }),
  view: { getContext: () => Promise.resolve({ siteUrl: '', localId: '' }) },
  router: { navigate: () => Promise.resolve() },
};
let forgeModule = null;
const loadForgeModule = async () => {
  if (!forgeModule) {
    try {
      const mod = await import('@forge/bridge');
      forgeModule = (typeof mod.invoke === 'function') ? mod : noopModule;
    } catch(e) {
      forgeModule = noopModule;
    }
  }
  return forgeModule;
};

const sleep = ms => new Promise(r => setTimeout(r, ms));

export async function saveModel (AppVersion) {
    openProgressModal({status: 'Saving model'})
    await sleep(20) // needed to display Progress

    let modelID = apiProvider.getModelID()
    const filters = JSON.stringify(apiProvider.retrieveFiltersArray())
    const visualizer_settings = JSON.stringify(apiProvider.retrieveVisualizerSettings())
    const costs = JSON.stringify(apiProvider.retrieveCosts())
    const workflow_configuration =  JSON.stringify(apiProvider.getWorkflowConfiguration())
    const workflow_transitions =  JSON.stringify(apiProvider.getWorkflowTransitions())
    const workflow_variants =  JSON.stringify(apiProvider.getWorkflowVariants())
   
    let gModelComments = apiProvider.retrieveModelComments()
    let gIssueComments = apiProvider.retrieveIssueComments()
    let gIssueWorklogs = apiProvider.retrieveIssueWorklogs()
    
    const model_comments = pako.deflate(convertToCSV(gModelComments), { to: 'string' })
    var model_comments_64 = Buffer.from(model_comments).toString('base64');
    const issue_comments = pako.deflate(convertToCSV(gIssueComments), { to: 'string' })
    var issue_comments_64 = Buffer.from(issue_comments).toString('base64');
    const issue_worklogs = pako.deflate(convertToCSV(gIssueWorklogs), { to: 'string' })
    var issue_worklogs_64 = Buffer.from(issue_worklogs).toString('base64');


    // remove discoveryRules where the data source = 'discovery'.  These will be recreated when loading the model
    let tempDiscoveryRules = [...apiProvider.retrieveDiscoveryRules()]
    /*
    for (let i = 0; i < tempDiscoveryRules.length; i++) {
        for (let k = 0; k < tempDiscoveryRules[i].filters.length; k++) {
            tempDiscoveryRules[i].filters[k].variants = []
            tempDiscoveryRules[i].filters[k].steps = []
            tempDiscoveryRules[i].filters[k].activities = []
        }
    }
    */

    let discoveryRules = []
    for (let j = 0; j < tempDiscoveryRules.length; j++) {
        if (tempDiscoveryRules[j].discovery_rule_type !== 'child') {discoveryRules.push(tempDiscoveryRules[j])}
    }
    let saveDiscoveryRules = JSON.stringify(discoveryRules)

    if (false) {
        let BASE_URL = `https://process-optimizer-jira.metricus.com/api/processmodel/retrieve`;
        let API = Axios.create({ baseURL: BASE_URL });
        let res = await API.get(apiProvider.getModelID());
        let processModels = res.data.data.processmodelData[0]

        BASE_URL = `https://process-optimizer-jira.metricus.com/api/processmodel/delete`;
        API = Axios.create({ baseURL: BASE_URL });
        res = await API.delete(apiProvider.getModelID());
        let data = JSON.stringify({
            id: apiProvider.getModelID(),
            customer_id: processModels.customer_id,
            name: processModels.name,
            description: processModels.description,
            projects: processModels.projects ,
            issue_types: processModels.issue_types ,
            attributes: processModels.attributes,
            jql: processModels.jql,
            activity_types: processModels.activity_types,
            from_date: processModels.from_date,
            to_date: processModels.to_date,
            total_issues: processModels.total_issues,
            anonymize: processModels.anonymize,
            attribute_privacy: processModels.attribute_privacy || null,
            consulting_workspace: JSON.stringify(apiProvider.getConsultingWorkspace ? apiProvider.getConsultingWorkspace() : {}),
            calendar: processModels.calendar,
            schedule_start: processModels.schedule_start,
            schedule_repeat: processModels.schedule_repeat,
            schedule_every: processModels.schedule_every,
            schedule_mon: processModels.schedule_mon,
            schedule_tue: processModels.schedule_tue,
            schedule_wed: processModels.schedule_wed,
            schedule_thu: processModels.schedule_thu,
            schedule_fri: processModels.schedule_fri,
            schedule_sat: processModels.schedule_sat,
            schedule_sun: processModels.schedule_sun,
            schedule_time: processModels.schedule_time,
            schedule_timezone: processModels.schedule_timezone,
            next_schedule_time: processModels.next_schedule_time,
            previous_schedule_time: processModels.previous_schedule_time,
            discovery_rules: saveDiscoveryRules,
            costs: costs,
            model_comments: model_comments_64,
            issue_comments: issue_comments_64,
            issue_worklogs: issue_worklogs_64,
            filters: filters,
            settings: visualizer_settings,
            workflow_configuration: workflow_configuration,
            workflow_transitions: workflow_transitions,
            workflow_variants: workflow_variants,
            sample: processModels.sample,
            confluence_space: processModels.confluence_space || "",
            confluence_parent_page: processModels.confluence_parent_page || "",
            metric_array: processModels.metric_array,
            filtered_count: String(filteredTasksCount() || ''),
            ai_process_health_assessment:      processModels.ai_process_health_assessment      || null,
            ai_intelligence: processModels.ai_intelligence || null,
            ai_consulting_report:             processModels.ai_consulting_report          || null,
            ai_trend_analysis:                 processModels.ai_trend_analysis      || null,
            ai_execution_strategy:    processModels.ai_execution_strategy    || null,
            ai_framework_assessment: processModels.ai_framework_assessment || null,
            ai_quick_healthcheck: processModels.ai_quick_healthcheck || null,
            ai_framework_assessment: processModels.ai_framework_assessment || null,
            ai_quick_healthcheck: processModels.ai_quick_healthcheck || null
           });
        res = await Axios({
            method: 'POST',
            url: 'https://process-optimizer-jira.metricus.com/api/processmodel/create',
            headers: {'Content-Type': 'application/json'},
            data: data
        });
    }
    if (AppVersion === 'FORGE') {
        const { invoke } = await loadForgeModule();
        let res = await invoke('getProcessModel', {modelID });
        let processModels = res[0]
        
        await invoke('deleteProcessModel', {id: modelID });
        console.log('Ian Debug: ' + String(filteredTasksCount() || ''))
        try {
            await invoke('createProcessModel', {
            id: modelID,
            ...preserveProcessModelBillingFields(processModels),
            customer_id: processModels.customer_id,
            name: processModels.name,
            description: processModels.description,
            projects: processModels.projects ,
            issue_types: processModels.issue_types ,
            attributes: processModels.attributes,
            category: processModels.category,
            jql: processModels.jql,
            activity_types: processModels.activity_types,
            from_date: processModels.from_date,
            to_date: processModels.to_date,
            total_issues: processModels.total_issues,
            anonymize: processModels.anonymize,
            attribute_privacy: processModels.attribute_privacy || null,
            consulting_workspace: JSON.stringify(apiProvider.getConsultingWorkspace ? apiProvider.getConsultingWorkspace() : {}),
            ai_report_scope: processModels.ai_report_scope || null,
            calendar: processModels.calendar,
            schedule_start: processModels.schedule_start,
            schedule_repeat: processModels.schedule_repeat,
            schedule_every: processModels.schedule_every,
            schedule_mon: processModels.schedule_mon,
            schedule_tue: processModels.schedule_tue,
            schedule_wed: processModels.schedule_wed,
            schedule_thu: processModels.schedule_thu,
            schedule_fri: processModels.schedule_fri,
            schedule_sat: processModels.schedule_sat,
            schedule_sun: processModels.schedule_sun,
            schedule_time: processModels.schedule_time,
            schedule_timezone: processModels.schedule_timezone,
            next_schedule_time: processModels.next_schedule_time,
            previous_schedule_time: processModels.previous_schedule_time,
            discovery_rules: saveDiscoveryRules,
            costs: costs,
            model_comments: model_comments_64,
            issue_comments: issue_comments_64,
            issue_worklogs: issue_worklogs_64,
            filters: filters,
            settings: visualizer_settings,
            workflow_configuration: workflow_configuration,
            workflow_transitions: workflow_transitions,
            workflow_variants: workflow_variants,
            sample: processModels.sample,
            confluence_space: processModels.confluence_space || "",
            confluence_parent_page: processModels.confluence_parent_page || "",
            export_to_confluence: processModels.export_to_confluence,
            metric_array: processModels.metric_array,
            filtered_count: String(filteredTasksCount() || ''),
            ai_process_health_assessment: processModels.ai_process_health_assessment || null,
            ai_intelligence: processModels.ai_intelligence || null,
            ai_consulting_report: processModels.ai_consulting_report || null,
            ai_trend_analysis: processModels.ai_trend_analysis || null,
            ai_execution_strategy: processModels.ai_execution_strategy || null,
            ai_framework_assessment: processModels.ai_framework_assessment || null,
            ai_quick_healthcheck: processModels.ai_quick_healthcheck || null,
            event_log_saved: processModels.event_log_saved || 'true',
            schedule_active: processModels.schedule_active,
            gauges: processModels.gauges,
            show_gauges: processModels.show_gauges,
            activity_group_mappings: processModels.activity_group_mappings || null,
           });
        } catch (err) {
            console.log(`Error: ${err.message}`)
        }  
    }

    setSaveModel(false)

    closeProgressModal()


    
function convertToCSV(objArray) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';

    for (let i = 0; i < array.length; i++) {
        let line = '';
        for (let index in array[i]) {
            if (line != '') line += '^';

            line += array[i][index];
        }

        str += line + '\r\n';
    }

    return str;
}
}